import { createRouter, createWebHistory } from 'vue-router';

import store from "@/store.js"

import Login from '@/views/Login.vue';
import Dashboard from '@/views/Dashboard.vue';
import Profile from '@/views/Profile.vue';
import VehicleEntryAddView from '@/views/VehicleEntryAddView.vue';
import VehicleEntryEditView from '@/views/VehicleEntryEditView.vue';
import VehicleEntryListView from '@/views/VehicleEntryListView.vue';
import VehicleEntryDetailView from '@/views/VehicleEntryDetailView.vue';
import GuestbookAddView from '@/views/GuestbookAddView.vue';
import GuestbookDetailView from '@/views/GuestbookDetailView.vue';
import GuestbookEditView from '@/views/GuestbookEditView.vue';
import GuestbookListView from '@/views/GuestbookListView.vue';
import GatehouseView from '@/views/dashboard/GatehouseView.vue';
import GatehouseAddView from '@/views/dashboard/GatehouseAddView.vue';
import GatehouseEditView from '@/views/dashboard/GatehouseEditView.vue';
import CommodityUnitView from '@/views/dashboard/CommodityUnitView.vue';
import UsersView from '@/views/dashboard/UsersView.vue';
import ForgotPassword from '@/views/ForgotPassword.vue';
import ResetPassword from '@/views/ResetPassword.vue';
import RepeatingEvents from '@/views/RepeatingEvents.vue';
import AddRepeatingEvent from '@/views/AddRepeatingEvent.vue';
import RepeatingEventDetailView from '@/views/RepeatingEventDetailView.vue';
import RepeatingEventEditView from '@/views/RepeatingEventEditView.vue';

import MobileDeviceListView from '@/views/dashboard/MobileDeviceListView.vue';
import MobileDeviceDetailView from '@/views/dashboard/MobileDeviceDetailView.vue';
import PatrolRouteListView from '@/views/dashboard/PatrolRouteListView.vue';
import PatrolRouteDetailView from '@/views/dashboard/PatrolRouteDetailView.vue';
import PatrolRouteAddView from '@/views/dashboard/PatrolRouteAddView.vue';
import PatrolRouteEditView from '@/views/dashboard/PatrolRouteEditView.vue';
import NfcTagListView from '@/views/dashboard/NfcTagListView.vue';
import NfcTagDetailView from '@/views/dashboard/NfcTagDetailView.vue';
import NfcTagEditView from '@/views/dashboard/NfcTagEditView.vue';
import PatrolLogListView from '@/views/dashboard/PatrolLogListView.vue';
import PatrolLogDetailView from '@/views/dashboard/PatrolLogDetailView.vue';
import NotificationListView from '@/views/dashboard/NotificationListView.vue';

const routes = [
    {
        path: '/',
        name: 'login',
        component: Login,
        meta: {
            title: "titles.login",
            navbar: false,
        }
    },
    {
        path: '/logout/',
        name: 'logout',
        async beforeEnter(to, from, next) {
            // after logout redirect to login
            await store.getters.api.get("/auth/logout");
            store.commit("saveUserProfile", {});
            next({ name: "login" });
        }
    },
    {
        path: '/forgot-password',
        name: 'ForgotPassword',
        component: ForgotPassword,
        meta: {
            navbar: false
        }
    },
    {
        path: '/reset/:slug',
        name: 'ResetPassword',
        component: ResetPassword,
        meta: {
            title: "titles.password",
            navbar: false
        }
    },
    {
        path: '/:slug/dashboard',
        name: 'dashboard',
        component: Dashboard,
        meta: {
            title: "titles.dashboard",
            navbar: true,
        }
    },
    {
        path: '/profile',
        name: 'profile',
        component: Profile,
        meta: {
            title: "titles.profile",
            navbar: true,
        }
    },
    {
        path: "/:slug/vehicle-entries",
        name: "vehicleEntryListView",
        component: VehicleEntryListView,
        meta: {
            title: "titles.vehicles",
            navbar: true,
        }
    },
    {
        path: "/:slug/vehicle-entries/add",
        name: "vehicleEntryAddView",
        component: VehicleEntryAddView,
        meta: {
            title: "titles.vehicleAdd",
            navbar: true,
        }
    },
    {
        path: "/:slug/vehicle-entries/:id/edit",
        name: "vehicleEntryEditView",
        component: VehicleEntryEditView,
        meta: {
            title: "titles.vehicleEdit",
            navbar: true,
        }
    },
    {
        path: "/:slug/vehicle-entries/:id",
        name: "vehicleEntryDetailView",
        component: VehicleEntryDetailView,
        meta: {
            title: "titles.vehicleDetail",
            navbar: true,
        }
    },
    {
        path: "/:slug/guestbooks/add",
        name: "guestbookAddView",
        component: GuestbookAddView,
        meta: {
            title: "titles.guestbookAdd",
            navbar: true,
        }
    },
    {
        path: "/:slug/guestbooks/:id",
        name: "guestbookDetailView",
        component: GuestbookDetailView,
        meta: {
            title: "titles.guestbookDetail",
            navbar: true,
        }
    },
    {
        path: "/:slug/guestbooks/:id/edit",
        name: "guestbookEditView",
        component: GuestbookEditView,
        meta: {
            title: "titles.guestbookEdit",
            navbar: true,
        }
    },
    {
        path: "/:slug/guestbooks",
        name: "guestbookListView",
        component: GuestbookListView,
        meta: {
            title: "titles.guestbooks",
            navbar: true,
        }
    },
    {
        path: "/dashboard/:slug/gatehouse",
        name: "GatehouseView",
        component: GatehouseView,
        meta: {
            title: "titles.gatehouse",
            navbar: true,
            admin: true,
        }
    },
    {
        path: "/dashboard/:slug/gatehouse/add",
        name: "GatehouseAddView",
        component: GatehouseAddView,
        meta: {
            title: "titles.gatehouseAdd",
            navbar: true,
            admin: true,
        }
    },
    {
        path: "/dashboard/:slug/gatehouse/:id/edit",
        name: "GatehouseEditView",
        component: GatehouseEditView,
        meta: {
            title: "titles.gatehouseEdit",
            navbar: true,
            admin: true,
        }
    },
    {
        path: "/dashboard/:slug/units",
        name: "CommodityUnitView",
        component: CommodityUnitView,
        meta: {
            title: "titles.commodityUnits",
            navbar: true,
            admin: true,
        }
    },
    {
        path: "/dashboard/:slug/users",
        name: "UsersView",
        component: UsersView,
        meta: {
            title: "titles.users",
            navbar: true,
            admin: true,
        }
    },
    {
        path: "/dashboard/:slug/mobile-devices",
        name: "MobileDeviceListView",
        component: MobileDeviceListView,
        meta: {
            title: "titles.devices",
            navbar: true,
            admin: true,
        }
    },
    {
        path: "/dashboard/:slug/mobile-devices/:id",
        name: "MobileDeviceDetailView",
        component: MobileDeviceDetailView,
        meta: {
            title: "titles.deviceDetail",
            navbar: true,
            admin: true,
        }
    },
    {
        path: "/dashboard/:slug/patrols",
        name: "PatrolRouteListView_admin",
        component: PatrolRouteListView,
        meta: {
            title: "titles.patrolRoutes",
            navbar: true,
            admin: true,
        }
    },
    {
        path: "/:slug/patrols",
        name: "PatrolRouteListView",
        component: PatrolRouteListView,
        meta: {
            title: "titles.patrolRoutes",
            navbar: true,
            admin: false,
        }
    },
    {
        path: "/dashboard/:slug/patrols/:id",
        name: "PatrolRouteDetailView_admin",
        component: PatrolRouteDetailView,
        meta: {
            title: "titles.patrolRouteDetail",
            navbar: true,
            admin: true,
        }
    },
    {
        path: "/:slug/patrols/:id",
        name: "PatrolRouteDetailView",
        component: PatrolRouteDetailView,
        meta: {
            title: "titles.patrolRouteDetail",
            navbar: true,
            admin: false,
        }
    },
    {
        path: "/dashboard/:slug/patrols/add",
        name: "PatrolRouteAddView_admin",
        component: PatrolRouteAddView,
        meta: {
            title: "titles.patrolRouteAdd",
            navbar: true,
            admin: true
        }
    },
    {
        path: "/:slug/patrols/add",
        name: "PatrolRouteAddView",
        component: PatrolRouteAddView,
        meta: {
            title: "titles.patrolRouteAdd",
            navbar: true,
            admin: false
        }
    },
    {
        path: "/dashboard/:slug/patrols/:id/edit",
        name: "PatrolRouteEditView_admin",
        component: PatrolRouteEditView,
        meta: {
            title: "titles.patrolRouteEdit",
            navbar: true,
            admin: true
        }
    },
    {
        path: "/:slug/patrols/:id/edit",
        name: "PatrolRouteEditView",
        component: PatrolRouteEditView,
        meta: {
            title: "titles.patrolRouteEdit",
            navbar: true,
            admin: false
        }
    },
    {
        path: "/dashboard/:slug/nfc",
        name: "NfcTagListView",
        component: NfcTagListView,
        meta: {
            title: "titles.nfcTags",
            navbar: true,
            admin: true
        }
    },
    {
        path: "/dashboard/:slug/nfc/:id",
        name: "NfcTagDetailView",
        component: NfcTagDetailView,
        meta: {
            title: "titles.nfcTag",
            navbar: true,
            admin: true
        }
    },
    {
        path: "/dashboard/:slug/nfc/:id/edit",
        name: "NfcTagEditView",
        component: NfcTagEditView,
        meta: {
            title: "titles.nfcTagEdit",
            navbar: true,
            admin: true
        }
    },
    {
        path: "/dashboard/:slug/patrol-logs",
        name: "PatrolLogListView_admin",
        component: PatrolLogListView,
        meta: {
            title: "titles.patrolLogs",
            navbar: true,
            admin: true
        }
    },
    {
        path: "/:slug/patrol-logs",
        name: "PatrolLogListView",
        component: PatrolLogListView,
        meta: {
            title: "titles.patrolLogs",
            navbar: true,
            admin: false
        }
    },
    {
        path: "/dashboard/:slug/patrol-logs/:id",
        name: "PatrolLogDetailView_admin",
        component: PatrolLogDetailView,
        meta: {
            title: "titles.patrolLogDetail",
            navbar: true,
            admin: true
        }
    },
    {
        path: "/:slug/patrol-logs/:id",
        name: "PatrolLogDetailView",
        component: PatrolLogDetailView,
        meta: {
            title: "titles.patrolLogDetail",
            navbar: true,
            admin: false
        }
    },
    {
        path: "/dashboard/:slug/notifications",
        name: "NotificationListView",
        component: NotificationListView,
        meta: {
            title: "titles.notifications",
            navbar: true,
            admin: true
        }
    },
    {
        path: "/:slug/repeating-events",
        name: "RepeatingEvents",
        component: RepeatingEvents,
        meta: {
            title: "titles.recurringEvents",
            navbar: true,
            admin: false
        }
    },
    {
        path: "/:slug/guestbooks/:id/add-repeating-event",
        name: "AddRepeatingEvent_Guestbook",
        component: AddRepeatingEvent,
        meta: {
            title: "titles.recurringEvents",
            navbar: true,
            admin: false
        }
    },
    {
        path: "/:slug/vehicle-entries/:id/add-repeating-event",
        name: "AddRepeatingEvent_VehicleEntry",
        component: AddRepeatingEvent,
        meta: {
            title: "titles.recurringEvents",
            navbar: true,
            admin: false
        }
    },
    {
        path: "/:slug/repeating-events/:id",
        name: "RepeatingEventDetailView",
        component: RepeatingEventDetailView,
        meta: {
            title: "titles.recurringEventDetail",
            navbar: true,
            admin: false
        }
    },
    {
        path: "/:slug/repeating-events/:id/edit",
        name: "RepeatingEventEditView",
        component: RepeatingEventEditView,
        meta: {
            title: "titles.recurringEventEdit",
            navbar: true,
            admin: false
        }
    },
]

const router = createRouter({
    history: createWebHistory(),
    routes: routes
})

router.beforeEach((to, from, next) => {
    if (store.getters.isLoggedIn || to.name == 'login' || to.name == 'logout'
        || to.name == 'ForgotPassword' || to.name == 'ResetPassword') {
        if (to.params.slug) {
            store.commit("selectGatehouse", to.params.slug);
        }

        next();
    } else {
        next({ name: 'login', query: { path: to.path } });
    }
})

export default router;